import React from "react";
import { RouteObject } from "react-router";
import { LoggedInProps } from "modules/common/components/routing/AnonymousRoute";
import { ProtectedRoute } from "modules/common/components/routing/ProtectedRoute";
import { routes } from "modules/common/routes";
import { SessionType } from "modules/session/auth/models/session";
import { OrderMailsStoreType } from "./models/store";
import { OrderMailsPage } from "./components/OrderMailsPage";

export const buildRoutes = ({ store, session, loggedIn }: RoutesProps): RouteObject[] => [
    {
        path: `${routes.orders.mails}/*`,
        element: (
            <ProtectedRoute loggedIn={loggedIn}>
                <OrderMailsPage store={store} session={session} />
            </ProtectedRoute>
        ),
    },
];

interface RoutesProps extends LoggedInProps {
    store: OrderMailsStoreType;
    session: SessionType;
}
